import { SponsoredWidgetCountdownClockConsumptionModuleVariant } from 'pathfinder/rules-engine/modules/sponsoredWidgetsCountdownClockConsumptionModule';
export function variantToImageSize(variant) {
    switch (variant) {
        case SponsoredWidgetCountdownClockConsumptionModuleVariant.DESKTOP:
            return { width: 300, height: 450 };
        case SponsoredWidgetCountdownClockConsumptionModuleVariant.MOBILE:
            return { width: 300, height: 120 };
    }
}
